(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/coupon-row.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/coupon-row.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$tipse = svs.components.tipsen.couponScore,
  EventParticipantDistributions = _svs$components$tipse.EventParticipantDistributions,
  EventParticipantOutcome = _svs$components$tipse.EventParticipantOutcome;
const clx = svs.components.lbUtils.clx;
const Coupon = svs.components.tipsen.couponComponents.Coupon;
const engineConstants = svs.components.tipsen.engine.constants;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const _React = React,
  useContext = _React.useContext;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const getEventLink = svs.components.tipsen.tipsen_link.utils.getEventLink;
const useDrawSearchParams = svs.components.tipsen.drawProvider.hooks.useDrawSearchParams;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const STATISTIC_SIDEBAR_QUERY = svs.components.tipsen.constants.STATISTIC_SIDEBAR_QUERY;
const selectParticipant = svs.components.sportinfo.matchInfoRedux.selectors.selectParticipant;
const useBetEvent = svs.components.sportinfo.matchInfoHooks.useBetEvent;
const useIsTipsinfoEnabled = svs.components.tipsen.hooks.useIsTipsinfoEnabled;
const selectShowMatchAnalyseText = svs.components.tipsen.selectors.selectShowMatchAnalyseText;
const _svs$components$tipse2 = svs.components.tipsen.couponScore.couponRowSections,
  CouponRowHeader = _svs$components$tipse2.CouponRowHeader,
  CouponRowBody = _svs$components$tipse2.CouponRowBody,
  CouponRowFooter = _svs$components$tipse2.CouponRowFooter;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const _svs$components$tipse3 = svs.components.tipsen.tipsinfo,
  TipsinfoRow = _svs$components$tipse3.TipsinfoRow,
  TipsinfoRowText = _svs$components$tipse3.TipsinfoRowText;
const selectSportEvent = svs.components.sportinfo.matchInfoRedux.selectors.selectSportEvent;
const MATCHEN = svs.utils.products.productIds.MATCHEN;
const getAriaLabelForEvent = svs.components.poolBetting.ariaUtils.getAriaLabelForEvent;
const transformDistributionsByParticipant = distributions => {
  if (!Array.isArray(distributions)) {
    return [[], []];
  }
  const homeDistributions = distributions.map(subArray => subArray === null || subArray === void 0 ? void 0 : subArray[0]);
  const awayDistributions = distributions.map(subArray => subArray === null || subArray === void 0 ? void 0 : subArray[1]);
  return [homeDistributions, awayDistributions];
};
const LabelMap = {
  [engineConstants.ReductionScore.HOME]: 'Hemmaseger',
  [engineConstants.ReductionScore.DRAW]: 'Oavgjort',
  [engineConstants.ReductionScore.AWAY]: 'Bortaseger'
};
const CouponRow = _ref => {
  var _eventStatistics$dist;
  let _ref$drawNumber = _ref.drawNumber,
    drawNumber = _ref$drawNumber === void 0 ? 0 : _ref$drawNumber,
    _ref$eventNumber = _ref.eventNumber,
    eventNumber = _ref$eventNumber === void 0 ? 0 : _ref$eventNumber,
    _ref$productId = _ref.productId,
    productId = _ref$productId === void 0 ? 0 : _ref$productId,
    _ref$sportType = _ref.sportType,
    sportType = _ref$sportType === void 0 ? 0 : _ref$sportType;
  const _useContext = useContext(RenderContext),
    pageType = _useContext.pageType;
  const _useIsTipsinfoEnabled = useIsTipsinfoEnabled(),
    isSvenskaFolketEnabled = _useIsTipsinfoEnabled.isSvenskaFolketEnabled,
    isSvenskaFolketAsOutcomesEnabled = _useIsTipsinfoEnabled.isSvenskaFolketAsOutcomesEnabled,
    isBetPredictionEnabled = _useIsTipsinfoEnabled.isBetPredictionEnabled,
    isMatchStartEnabled = _useIsTipsinfoEnabled.isMatchStartEnabled;
  const _useBetEvent = useBetEvent({
      productId,
      drawNumber,
      eventNumber
    }),
    betEvent = _useBetEvent.betEvent,
    eventStatistics = _useBetEvent.eventStatistics;
  const eventComment = betEvent.eventComment,
    matchId = betEvent.matchId,
    participants = betEvent.participants,
    periodNumber = betEvent.periodNumber;
  const _useContext2 = useContext(DrawContext),
    selectedEventNumber = _useContext2.eventNumber;
  const hasPeriodNumber = periodNumber > 0;
  const toParams = useDrawSearchParams(productId, drawNumber, eventNumber);
  const searchParams = new URLSearchParams(toParams);
  const showCouponAndDetailView = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  if (!showCouponAndDetailView) {
    searchParams.set('openStatistic', '');
  }
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const homeParticipant = useSelector(state => selectParticipant(state, participants[0]));
  const awayParticipant = useSelector(state => selectParticipant(state, participants[1]));
  const homeTeamName = homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.name;
  const awayTeamName = awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.name;
  const isSelected = showCouponAndDetailView && eventNumber === selectedEventNumber;
  const distributions = isSvenskaFolketEnabled || isSvenskaFolketAsOutcomesEnabled ? (eventStatistics === null || eventStatistics === void 0 || (_eventStatistics$dist = eventStatistics.distributions) === null || _eventStatistics$dist === void 0 || (_eventStatistics$dist = _eventStatistics$dist[productId]) === null || _eventStatistics$dist === void 0 || (_eventStatistics$dist = _eventStatistics$dist[drawNumber]) === null || _eventStatistics$dist === void 0 || (_eventStatistics$dist = _eventStatistics$dist.current) === null || _eventStatistics$dist === void 0 ? void 0 : _eventStatistics$dist.value) || [] : [];
  const distributionsByParticipant = transformDistributionsByParticipant(distributions);
  const shouldShowDistributionsComponent = !isSmallDevice && !isSvenskaFolketAsOutcomesEnabled && distributions.length > 0 && productId !== MATCHEN;
  const showBetPredictionsInCoupon = isBetPredictionEnabled && !hasPeriodNumber;
  const isAnalysisSelected = useSelector(state => selectShowMatchAnalyseText(state, pageType));
  const showMatchAnalysesInCoupon = !hasPeriodNumber && isAnalysisSelected;
  const sportEvent = useSelector(state => selectSportEvent(state, matchId));
  const shouldDisplayMatchstart = isMatchStartEnabled;

  return React.createElement("li", {
    className: clx('pg_coupon_row', {
      'pg_coupon_row--selected': isSelected
    }),
    key: eventNumber
  }, React.createElement(TipsenLink, _extends({
    "aria-label": getAriaLabelForEvent({
      eventTypeId: betEvent === null || betEvent === void 0 ? void 0 : betEvent.eventTypeId,
      homeParticipant,
      awayParticipant
    }),
    className: "pg_coupon_row_link",
    to: {
      pathname: getEventLink(),
      search: "?".concat(searchParams)
    }
  }, isSelected ? {
    'aria-current': 'page'
  } : {}), React.createElement("span", {
    className: "sr-only"
  }, "".concat(homeTeamName, " vs. ").concat(awayTeamName))), hasPeriodNumber && React.createElement(CouponRowHeader, {
    className: "pg_coupon_row__period"
  }, "Period ".concat(periodNumber)), React.createElement(CouponRowBody, null, React.createElement("div", {
    className: "pg_coupon_row__event"
  }, [0, 1].map(eventGroupIndex => React.createElement("div", {
    className: "pg_coupon_row__event__participant",
    key: eventGroupIndex
  }, React.createElement("div", {
    className: "pg_coupon_row__event__participant__name"
  }, eventGroupIndex === 0 ? homeTeamName : awayTeamName), React.createElement(EventParticipantOutcome, {
    distributions: distributionsByParticipant[eventGroupIndex],
    eventNumber: eventNumber,
    eventTypeId: betEvent.eventTypeId,
    outcomeGroupIndex: eventGroupIndex,
    participants: participants,
    productId: productId,
    sportType: sportType,
    teamName: eventGroupIndex === 0 ? homeTeamName : awayTeamName
  })))), shouldDisplayMatchstart && sportEvent.matchStart && React.createElement(TipsinfoRow, {
    className: "pg_coupon_row__match_start",
    date: sportEvent.matchStart,
    title: "Matchstart:"
  }, React.createElement(TipsinfoRowText, {
    className: "pg_coupon_row__match_start__date"
  }, svs.components.lbUtils.helpers.formatDate.formatDate(sportEvent.matchStart, true, true, true))), eventComment && React.createElement("div", {
    className: "pg_coupon_row__web_text"
  }, React.createElement(Coupon.WebText, {
    eventComment: eventComment
  })), (showBetPredictionsInCoupon || showMatchAnalysesInCoupon) && React.createElement("div", {
    className: "pg_coupon_row__analysis_section"
  }, showBetPredictionsInCoupon && React.createElement("div", {
    className: "pg_coupon_row__bet_predictions"
  }, React.createElement(Coupon.BetPrediction, {
    drawNumber: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  })), showMatchAnalysesInCoupon && React.createElement("div", {
    className: "pg_coupon_row__analyzes"
  }, React.createElement(Coupon.GameAnalysis, {
    drawNumber: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  })))), React.createElement(CouponRowFooter, null, React.createElement("div", {
    className: "pg_coupon_row__reductions"
  }, React.createElement("div", {
    className: "pg_coupon_row__reductions__text"
  }, "V\xE4lj bort resultat"), React.createElement("div", {
    className: "pg_coupon_row__reductions__labels"
  }, React.createElement(Coupon.Reductions, {
    eventNumber: eventNumber,
    labelMap: LabelMap
  })))));
};
setGlobal('svs.components.tipsen.couponScore.CouponRow', CouponRow);

 })(window);